import api from '@utils/api';
import React from 'react';
import { useTranslation } from 'react-i18next';
const DoubleOptInForm = (props) => {
    const { t } = useTranslation();
    const sendEmail = () => {
        api.sendClothingDoubleOptIn(props.loginEmail);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("p", { dangerouslySetInnerHTML: {
                __html: !props.fromRegister ? t('login.clothing.welcomebackdoubleoptin', { 0: props.loginEmail }) : t('login.clothing.registerdoubleoptin', { 0: props.loginEmail }),
            } }),
        React.createElement("div", { className: "row mt-24 send-email-clothing" },
            React.createElement("p", null,
                t('login.clothing.sendagaintext'),
                "\u00A0"),
            React.createElement("button", { className: "link", onClick: () => sendEmail() }, t('login.clothing.sendagain')))));
};
export default DoubleOptInForm;
